<div class="name">
<span class="title"
      [class.disabled]="tray?.disabled">  {{ getName(tray) }}
</span>
    <div class="indicator"
         [class.disabled]="tray?.disabled">
    </div>
</div>
<div class="slots">
    <app-slot *ngFor="let slot of tray?.slots"
              [slot]="slot"
              (select)="onSlotClick(slot)"></app-slot>
</div>
<div class="controls">
    <app-icon [simple]="true"
              class="control edit"
              library="material"
              variant="play_arrow"
              type="info"
              (click)="editTrayClick()">
    </app-icon>
    <app-icon [simple]="true"
              class="control no-show"
              library="fontawesome"
              [variant]="computeVisibilityIcon(tray.disabled)"
              type="info"
              [pTooltip]="'admin.lifts.notifications.changeVisibilityTray' | translate"
              [tooltipPosition]="'top'"
              (click)="toggleTrayStateClick()">
    </app-icon>
    <app-icon [simple]="true"
              class="control delete"
              library="material"
              variant="delete"
              type="info"
              (click)="deleteTrayClick()">
    </app-icon>
</div>
